import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { completeRedirectFromSlack } from '@src/api'
import {
  CompleteRedirectFromSlack200Response,
  DefaultApiCompleteRedirectFromSlackRequest,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchCompleteRedirectFromSlack = (
  params: DefaultApiCompleteRedirectFromSlackRequest
) => {
  const { axiosInstance } = useAxios()
  const { completeRedirectFromSlackRequest } = params

  return useQuery<
    AxiosResponse<CompleteRedirectFromSlack200Response>,
    AxiosResponse<CustomError>
  >({
    enabled:
      !!completeRedirectFromSlackRequest?.channelId &&
      !!completeRedirectFromSlackRequest?.messageTimestamp &&
      !!completeRedirectFromSlackRequest?.slackUserId,
    queryFn: () => completeRedirectFromSlack(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.COMPLETE_REDIRECT_FROM_SLACK,
      params.completeRedirectFromSlackRequest?.channelId,
      params.completeRedirectFromSlackRequest?.messageTimestamp,
      params.completeRedirectFromSlackRequest?.slackUserId,
    ],
  })
}
